import { track } from "../track";

export const trackSignUpTry = (params: {
  email: string;
  name?: string;
  quiz_id?: string;
}) => track({ event: "sign_up_try", ...params });
